import React from 'react';
import { useAuth } from '../contexts/AuthContext';

// Subtle global "you're in the sandbox" ribbon for the investor demo reviewer.
// Rendered in-flow at the very top of the app shell so it shows above every
// page's own header (public navbar or dashboard headers alike).
export default function DemoRibbon() {
  const { user } = useAuth();
  if (!user?.is_demo_reviewer) return null;
  return (
    <div className="w-full bg-coral-600 text-white" data-testid="demo-mode-ribbon">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 h-7 flex items-center justify-center gap-2 text-[11px] leading-none">
        <span className="uppercase tracking-[0.2em] font-bold">Demo, reviewer mode</span>
        <span className="hidden sm:inline text-white/80">· live sandbox, nothing here affects real customers</span>
      </div>
    </div>
  );
}
